<template>
  <div>
    <custom-callout border-color="#FF7058" :has-toggle="false">
      <div class="py-2">
        <div class="d-flex">
          <icon-view
            class="mt-5 mb-3 mt-md-0 mt-sm-5"
            :gradient="false"
            icon="far fa-file-invoice p-2"
            icon-background="#ff7058"
            icon-color="white"
            icon-size="14px"
            :title="title"
          />
        </div>
        <validation-observer ref="formObserver">
          <div class="row p-2">
            <div class="col-md-4">
              <validation-provider v-slot="{ errors }" :rules="'required'">
                <custom-drop-down
                  v-model="model.area"
                  class="w-100"
                  :custom-error-msg="'El área es requerida.'"
                  :error="errors[0]"
                  fieldkey="id"
                  fieldname="name"
                  label="Área:"
                  :options="collections.areas"
                  placeholder="Seleccione"
                  @input="onAreaChange"
                />
              </validation-provider>
            </div>

            <div class="col-md-4">
              <validation-provider v-slot="{ errors }" :rules="'required'">
                <custom-drop-down
                  v-model="model.service"
                  class="w-100"
                  :custom-error-msg="'El servicio es requerida.'"
                  :error="errors[0]"
                  fieldkey="id"
                  fieldname="name"
                  label="Servicio a Ofrecer:"
                  :options="services"
                  placeholder="Seleccione"
                />
              </validation-provider>
            </div>
            <div class="col-md-4">
              <validation-provider v-slot="{ errors }" :rules="'required'">
                <custom-input
                  v-model="model.questionnaireName"
                  :custom-error-msg="'El nombre del cuestionario es requerido.'"
                  :error="errors[0]"
                  label="Nombre de Cuestionario:"
                  maxlength="100"
                  type="text"
                />
              </validation-provider>
            </div>
          </div>
          <div class="d-flex justify-content-end mt-3">
            <action-button
              i="fas fa-times-circle"
              text="Cancelar"
              variant="outline-danger mr-3 pl-3 pr-4"
              @click="onCancelHandler"
            />
            <action-button
              i="fas fa-arrow-circle-right"
              text="Continuar"
              variant="success pl-3 pr-3"
              @click="onSaveHandler"
            />
          </div>
        </validation-observer>
      </div>
    </custom-callout>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';
import CustomDropDown from 'custom-drop-down';
import IconView from 'icon-view';
import { getServiceTypesByArea } from '@/modules/serviceProposalHistory/api';
import CustomInput from 'CustomInput';
import alertMixin from '@/mixins/alert.mixin.js';
import { save } from '@/modules/bidQuestionConfig/api.js';

export default {
  name: 'AddQuestionConfig',
  components: {
    CustomCallout,
    ActionButton,
    CustomDropDown,
    IconView,
    CustomInput,
  },
  mixins: [alertMixin],
  props: {
    collections: {
      type: Object,
      default: () => {},
    },
    copyFrom: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      services: [],
      model: {
        area: null,
        service: null,
        questionnaireName: null,
      },
    };
  },
  computed: {
    title() {
      return this.copyFrom ? 'Duplicar Cuestionario' : 'Generar Cuestionario';
    },
  },
  async mounted() {
    if (this.copyFrom) {
      this.model.area = this.copyFrom.area;
      await this.onAreaChange(this.model.area);
      this.model.service = this.copyFrom.service;
    }
  },
  methods: {
    onCancelHandler() {
      this.$emit('on-cancel');
    },
    async onAreaChange(area) {
      this.services = [];
      this.model.service = null;
      if (!area) return;

      const { data } = await getServiceTypesByArea(area.id);
      this.services = data;
    },

    async onSaveHandler() {
      const isValid = await this.$refs.formObserver.validate();
      if (!isValid) {
        this.ShowToast(
          '',
          'Favor, debe completar los campos para continuar.',
          'error'
        );
        return;
      }

      try {
        const payload = {
          areaId: this.model.area.id,
          serviceId: this.model.service.id,
          questionnaireName: this.model.questionnaireName,
          copyFromId: this.copyFrom ? this.copyFrom.id : null,
        };

        const { data } = await save(payload);

        this.ShowToast('', 'Proceso completado exitosamente.', 'success');

        if (data) {
          this.$router.push({
            name: 'questionConfigurationDetail',
            params: {
              id: data,
            },
          });
        }

        this.onCancelHandler();
      } catch (error) {
        this.ShowToast(
          '',
          'Ha ocurrido un error al crear la configuración de preguntas para pliegos.',
          'error'
        );
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .dot {
    width: 30px !important;
    height: 30px !important;
  }
}

// Estilos generales para los textos
.text-normal {
  color: black;
  font-size: 14px;
  font-family: Lato;
  font-weight: 400;
  line-height: 16.8px;
  word-wrap: break-word;
}

.text-bold {
  color: black;
  font-size: 14px;
  font-family: Lato;
  font-weight: 700;
  line-height: 16.8px;
  word-wrap: break-word;
}

li {
  line-height: 30px;
}
</style>
